import {
  formatName,
  matchupHeadline,
  STATS,
  summarizeMatchup,
  totalLine,
} from '../utils/pokemon';

function barWidth(value, other) {
  const scale = Math.max(value, other, 1);
  return `${Math.round((value / scale) * 100)}%`;
}

function StatComparison({ pokemon1, pokemon2 }) {
  const summary = summarizeMatchup(pokemon1, pokemon2);
  const leftName = formatName(pokemon1.name);
  const rightName = formatName(pokemon2.name);

  return (
    <section className="stat-board" aria-live="polite" aria-label="Stat comparison">
      <div className="scoreline">
        <h2>{matchupHeadline(pokemon1, pokemon2, summary)}</h2>
        <p>{totalLine(pokemon1, pokemon2, summary)}</p>
      </div>
      <p className="legend">
        <span className="swatch swatch-left" aria-hidden="true" />
        {leftName}
        <span className="swatch swatch-right" aria-hidden="true" />
        {rightName}
      </p>
      <div className="stat-list">
        {STATS.map(({ key, label }) => {
          const left = pokemon1.stats[key];
          const right = pokemon2.stats[key];
          const winner = summary.stats[key];
          const spoken =
            winner === 'tie'
              ? `${label} tied at ${left}`
              : winner === 'pokemon1'
                ? `${label}, ${leftName} ${left}, ${rightName} ${right}, ${leftName} wins`
                : `${label}, ${leftName} ${left}, ${rightName} ${right}, ${rightName} wins`;

          return (
            <div className="stat-row" key={key} role="group" aria-label={spoken}>
              <span className={`stat-value ${winner === 'pokemon1' ? 'is-winner' : ''}`}>
                {left}
                {winner === 'tie' && <span className="win-tag">Tie</span>}
                {winner === 'pokemon1' && <span className="win-tag">Wins</span>}
              </span>
              <span className="bar bar-left" aria-hidden="true">
                <span
                  className={`fill ${winner === 'pokemon2' ? 'is-behind' : ''}`}
                  style={{ width: barWidth(left, right) }}
                />
              </span>
              <span className="stat-label" aria-hidden="true">{label}</span>
              <span className="bar bar-right" aria-hidden="true">
                <span
                  className={`fill ${winner === 'pokemon1' ? 'is-behind' : ''}`}
                  style={{ width: barWidth(right, left) }}
                />
              </span>
              <span className={`stat-value stat-value-right ${winner === 'pokemon2' ? 'is-winner' : ''}`}>
                {winner === 'tie' && <span className="win-tag">Tie</span>}
                {winner === 'pokemon2' && <span className="win-tag">Wins</span>}
                {right}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default StatComparison;
